import { Routes, Route, Link } from 'react-router-dom';


// Main pages
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Services from './pages/Services.jsx';
import Contact from './pages/Contact.jsx';
import BookAppointment from './pages/BookAppointment.jsx';
import Blog from './pages/Blog.jsx';

// Treatment sub-pages
import PediatricDentistry from './pages/Treatments/PediatricDentistry.jsx';
import GumCare from './pages/Treatments/GumCare.jsx';
import Endodontic from './pages/Treatments/Endodontics.jsx';
import LaserDentistry from './pages/Treatments/LaserDentistry.jsx';
import CrownsAndBridges from './pages/Treatments/CrownsBridges.jsx';
import Dentures from './pages/Treatments/Dentures.jsx';
import OralAndMaxillofacialSurgery from './pages/Treatments/OralMaxillofacialSurgery.jsx';
import DentalImplants from './pages/Treatments/DentalImplants.jsx';
import Orthodontics from './pages/Treatments/OrthodonticsBraces.jsx';
import CosmeticDentistry from './pages/Treatments/CosmeticDentistry.jsx';
import Gallery from './pages/Gallery.jsx';
// Layout & shared components
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import WhatsAppFloat from './components/layout/WhatsAppFloat.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

function App() {
  return (
    <>
      <Header />
      <ScrollToTop />

      <Routes>
        {/* Main routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/book-appointment" element={<BookAppointment />} />

        {/* Treatments section */}
        <Route path="/treatments">
          <Route path="pediatric-dentistry" element={<PediatricDentistry />} />
          <Route path="gum-care" element={<GumCare />} />
          <Route path="endodontic" element={<Endodontic />} />
          <Route path="laser-dentistry" element={<LaserDentistry />} />
          <Route path="crowns-and-bridges" element={<CrownsAndBridges />} />
          <Route path="dentures" element={<Dentures />} />
          <Route path="oral-maxillofacial-surgery" element={<OralAndMaxillofacialSurgery />} />
          <Route path="dental-implants" element={<DentalImplants />} />
          <Route path="orthodontics" element={<Orthodontics />} />
          <Route path="cosmetic-dentistry" element={<CosmeticDentistry />} />

        </Route>

        {/* Optional: 404 fallback */}
        <Route path="*" element={
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
              <p className="text-2xl text-gray-700 mb-8">Page Not Found</p>
              <Link 
                to="/" 
                className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition"
              >
                Back to Home
              </Link>
            </div>
          </div>
        } />
      </Routes>

      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default App;